module.exports = "/images/Homepage-Integrations_FeaturesM.jpg";